export var Direction;
(function (Direction) {
    Direction[Direction["FORWARD"] = 1] = "FORWARD";
    Direction[Direction["REVERSE"] = -1] = "REVERSE";
})(Direction || (Direction = {}));
